export const usmle2EmergencyModule = {
  id: "emergency",
  title: "Emergency",
  sections: [
    {
      type: "text",
      content:
        "Unstable SVT requires immediate synchronized cardioversion.",
    },
    {
      type: "question",
      text: "First-line for anaphylaxis with airway compromise?",
      options: ["IM epinephrine", "Antihistamine only", "Steroid only", "Observation"],
      correct: 0,
      explanation: "IM epinephrine is first-line for anaphylaxis.",
    },
  ],
};
